/**
 * Iter-412 §3 — multi-store: active-store selection.
 *
 * The shared backend scopes EVERY /vendors/me* call to a store via the
 * `X-Store-Id` header (omitted = oldest store). The chosen store id is
 * persisted per-device; the sharedApi request interceptor injects the
 * header, and a window event lets React surfaces re-render on switch.
 */

const KEY = "allsale_active_store";
export const ACTIVE_STORE_EVENT = "allsale:active-store-changed";

export function getActiveStoreId() {
  try {
    const v = localStorage.getItem(KEY);
    return v && v !== "undefined" && v !== "null" ? v : null;
  } catch {
    return null;
  }
}

export function setActiveStoreId(id) {
  try {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
  } catch { /* private mode */ }
  window.dispatchEvent(new CustomEvent(ACTIVE_STORE_EVENT, { detail: { id: id || null } }));
}
